import { FC } from 'react';
import { Link } from 'react-router-dom';
import { getLoanTypeNameFromLoanTypeId } from '../../helpers';
import { Loan } from '../../interfaces';
import LocationBadge from '../Common/LocationBadge';
import VerifiedBadge from '../Common/VerifiedBadge';

type Props = {
  investment: Loan;
};

export const InvestmentRow: FC<Props> = ({ investment }) => {
  return (
    <tr>
      <td className='ps-3'>
        <div className='d-flex align-items-center'>
          <div className='d-flex justify-content-start flex-column'>
            <Link to={`/loan/${investment.id}`} className='text-dark text-capitalize fw-bold text-hover-primary mb-1 fs-6'>
              {investment.title}
            </Link>
            <LocationBadge location={`${investment.borrower.address_state.name}, ${investment.borrower.address_country.name}`} />
            <div className='mt-2'>
              <span className='badge badge-light-info fs-6 fw-bold'>{getLoanTypeNameFromLoanTypeId(investment.loan_type_id)}</span>
              <VerifiedBadge />
            </div>
          </div>
        </div>
      </td>
      <td className='align-top'>
        <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{`${parseFloat(investment.amount).toLocaleString()}`}</span>
      </td>
      <td className='align-top'>
        <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{`${investment.tenure} months`}</span>
      </td>
      <td className='align-top'>
        <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{investment.interest}</span>
      </td>
      <td className='text-end align-top pe-3'>
        <Link to={`/loan/${investment.id}`} className='btn  btn-light-warning  btn-sm me-1 fw-bold'>
          view
        </Link>
      </td>
    </tr>
  );
};
